import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../common/global-constants';
import * as ngswal from "sweetalert";
import { ConversionRulesAPIModel } from './conversion-rules-model';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { Router } from '@angular/router';
declare var $;


@Component({
  selector: 'app-conversionrules',
  templateUrl: './conversionrules.component.html',
  styleUrls: ['./conversionrules.component.css']
})
export class ConversionrulesComponent implements OnInit {
  modelItem = new ConversionRulesAPIModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  showpopup: boolean;
  showRulesModal: boolean;
  RulesModalButton: string = "Submit"
  title: string;
  publisherType: string;
  productType: any;
  referenceStyle: any;
  journalList: any;
  Title: String;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();


    $('#divRules1,#divRules2,#divRules3,#divRules4,#divRules5,#divRules6').css('height', (GlobalConstants.size.height) - 150);

  }
  constructor(private router: Router) {

    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ConversionRulesAPIModel>data["ConversionRulesPage"];
        this.getSetOptions();
        this.GetConversionRules();


        $("#ddlJournalList").select2({
          placeholder: "Select Journals", dropdownParent: "#divRules1"
        });
        $("#ddlJournalList").val([]).trigger("change");

        $("#ddlPublisherType").select2({
          placeholder: "Select Publisher Type", dropdownParent: "#divRules1"
        });
        $("#ddlPublisherType").val([]).trigger("change");

        $("#ddlProductType").select2({
          placeholder: "Select Product Type", dropdownParent: "#divRules1"
        });
        $("#ddlProductType").val([]).trigger("change");

        $("#ddlReferenceStyle").select2({
          placeholder: "Select Reference Style", dropdownParent: "#divRules1"
        });
        $("#ddlReferenceStyle").val([]).trigger("change");

        $("#RulesDegrees").select2({
          placeholder: "Select ", dropdownParent: "#divRules1"
        });
        $("#RuleAffiliation").select2({
          placeholder: "Select", dropdownParent: "#divRules1"
        });
        $("#RuleAbstracthead").select2({
          placeholder: "Select", dropdownParent: "#divRules1"
        });
        $("#RuleDisclosureSection").select2({
          placeholder: "Select", dropdownParent: "#divRules1"
        });
        $("#RuleFundingSection").select2({
          placeholder: "Select", dropdownParent: "#divRules1"
        });
        $("#RuleCorresspondingAddress").select2({
          placeholder: "Select", dropdownParent: "#divRules1"
        });



      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngAfterViewChecked(): void {


  }


  GetConversionRules() {
    $("#LoadingImage").show();

    var ConversionRulesData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.ConversionRulesAPI, ConversionRulesData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "btn_AddNew";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 160);
        dataItem.modulename = "ConversionRuleModule";
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //dropdown list get from table
  getSetOptions() {
    //$("#LoadingImage").show();

    ApiMethod.getMethod(this.modelItem.GetRulesOptions + '/' + localStorage.aPubID).subscribe(
      response => {

        this.publisherType = response.ConversionRuleOptions.PublisherType;
        this.productType = response.ConversionRuleOptions.ProductType;
        this.referenceStyle = response.ConversionRuleOptions.ReferenceStyle;
        this.journalList = response.ConversionRuleOptions.Journalname;

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  showConversionRules() {
    this.showRulesModal = true;
    this.cleardata();

    if (localStorage.aEID != 0) {
      ApiMethod.getMethod(this.modelItem.ConversionRulesDetailsAPI + '/' + localStorage.aEID).subscribe(
        response => {
          var details = response.aConversionRuleDetails;
          console.log(details);

          $('#txtConversionruleName').val(details.ConversionRuleName);
          $("#ddlJournalList").val(details.JournalId).change();
          $("#ddlPublisherType").val(details.PublisherType).change();
          $("#ddlProductType ").val(details.ProductType).change();
          $("#ddlReferenceStyle ").val(details.ReferenceStyle).change();
          $('#RulesDegrees').val(details.Degrees).change();
          $('#RuleAffiliation').val(details.Affiliation).change();
          $('#RuleAbstracthead').val(details.AbstractHead).change();
          $('#RuleDisclosureSection').val(details.DisclosureSection).change();
          $('#RuleFundingSection').val(details.FundingSection).change();
          $('#RuleCorresspondingAddress').val(details.CorrespondingAddress).change();
          $('#RuleTitle').val(details.Title);
          $('#RulesLRH').val(details.LRH);
          $('#RuleRRH').val(details.RRH);
          $('#RuleAuthorGroup').val(details.AuthorGroup);
          $('#RuleCorresspondingText').val(details.CorrespondingText);
          $('#RuleAffiliationElements').val(details.AffiliationElements);
          $('#RuleAffiliationIndicator').val(details.AffiliationIndicator);
          $('#RuleHistoryFormat').val(details.HistoryFormat);
          $('#RulesThousandSeparator').val(details.ThousandSeparator);
          $('#RuleQuotation').val(details.Quotation);
          $('#RuleCommaIEEG').val(details.CommaIEEG);
          $('#RulesParentheticalDash').val(details.ParentheticalDash);
          $('#RuleCenturies').val(details.Centuries);
          $('#RuleYearApos').val(details.YearApos);
          $('#RulesDashes').val(details.Dashes);
          $('#RuleSection1').val(details.Section1);
          $('#RuleSection2').val(details.Section2);
          $('#RuleSection3').val(details.Section3);
          $('#RuleSection4').val(details.Section4);
          $('#RuleKeywords').val(details.Keywords);
          $('#RuleBiographySection').val(details.BiographySection);
          $('#RuleTableCaption').val(details.TableCaption);
          $('#RulesTableCitation').val(details.TableCitation);
          $('#RuleFigureCaption').val(details.FigureCaption);
          $('#RuleFigureCitation').val(details.FigureCitation);
          $('#RuleBibArticleTitle').val(details.BibArticleTitle);
          $('#RuleJournalTitle').val(details.JournalTitle);
          $('#RuleChapterTitle').val(details.ChapterTitle);
          $('#RuleBookTitle').val(details.BookTitle);
          $('#RuleReportTitle').val(details.ReportTitle);
          $('#RuleConferenceTitle').val(details.ConferenceTitle);
          $('#RuleThesisTitle').val(details.ThesisTitle);
          $('#RuleConferenceName').val(details.conferenceName);
          $('#RulePaperTitle').val(details.PaperTitle);
          $('#RulepageRange').val(details.PageRange);
          $('#RuleNoteStyle').val(details.Notestyle);
          $('#RuleDataAvailabilitySection').val(details.DataAvailabilitySection);
          $('#RuleEthicalApprovalSection').val(details.EthicalApprovalSection);
          $('#RuleInformedConsentSection').val(details.InformedConsentSection);
          $('#RuleTrialRegistrationSection').val(details.TrialRegistrationSection);
          $('#RuleSupplementarySection').val(details.SupplementarySection);
          $('#RuleAuthorContributionSection').val(details.AuthorContributionSection);
          $('#RuleAbstractCount').val(details.AbstractCount);
          $('#RuleGraphicalAbstract').val(details.GraphicalAbstract);
          $('#RuleBackmatterOrder').val(details.BackmatterOrder);

          
        },
        error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
      this.RulesModalButton = "Update";
      this.Title = "Update Conversion Rules";
    }
    else {
      this.RulesModalButton = "Add";
      this.Title = "Add Conversion Rules";
    }

  }

  addUpdateConversionRules() {
    if ($('#ddlJournalList').val() == null) {
      ngswal("Warning !", "Enter Journal!", "warning");
    }
    else if ($('#ddlPublisherType').val() == null) {
      ngswal("Warning !", "Enter Publisher Type!", "warning");
    }
    else if ($('#ddlProductType').val() == null) {
      ngswal("Warning !", "Enter Product Type!", "warning");
    }
    else if ($('#ddlReferenceStyle').val() == null) {
      ngswal("Warning !", "Enter Reference Style!", "warning");
    }
    else {
      var conversionrulesdata =
      {
        Id: localStorage.aEID,
        PublisherId: localStorage.aPubID,
        JournalId: $("#ddlJournalList").val().toString(),
        JournalName: $("#ddlJournalList").val().toString(),
        PublisherType: $("#ddlPublisherType").val().toString(),
        ProductType: $("#ddlProductType").val().toString(),
        ReferenceStyle: $("#ddlReferenceStyle").val().toString(),
        ConversionRuleName: $("#txtConversionruleName").val(),
        Degrees: $("#RulesDegrees").val(),
        Affiliation: $("#RuleAffiliation").val(),
        AbstractHead: $("#RuleAbstracthead").val(),
        DisclosureSection: $("#RuleDisclosureSection").val(),
        FundingSection: $("#RuleFundingSection").val(),
        CorrespondingAddress: $("#RuleCorresspondingAddress").val(),
        Title: $("#RuleTitle").val(),
        LRH: $("#RulesLRH").val(),
        RRH: $("#RuleRRH").val(),
        AuthorGroup: $("#RuleAuthorGroup").val(),
        CorrespondingText: $("#RuleCorresspondingText").val(),
        AffiliationElements: $("#RuleAffiliationElements").val(),
        AffiliationIndicator: $("#RuleAffiliationIndicator").val(),
        HistoryFormat: $("#RuleHistoryFormat").val(),
        ThousandSeparator: $("#RulesThousandSeparator").val(),
        Quotation: $("#RuleQuotation").val(),
        CommaIEEG: $("#RuleCommaIEEG").val(),
        ParentheticalDash: $("#RulesParentheticalDash").val(),
        Centuries: $("#RuleCenturies").val(),
        YearApos: $("#RuleYearApos").val(),
        Dashes: $("#RulesDashes").val(),
        Section1: $("#RuleSection1").val(),
        Section2: $("#RuleSection2").val(),
        Section3: $("#RuleSection3").val(),
        Section4: $("#RuleSection4").val(),
        Keywords: $("#RuleKeywords").val(),
        BiographySection: $("#RuleBiographySection").val(),
        TableCaption: $("#RuleTableCaption").val(),
        TableCitation: $("#RulesTableCitation").val(),
        FigureCaption: $("#RuleFigureCaption").val(),
        FigureCitation: $("#RuleFigureCitation").val(),
        BibArticleTitle: $("#RuleBibArticleTitle").val(),
        JournalTitle: $("#RuleJournalTitle").val(),
        ChapterTitle: $("#RuleChapterTitle").val(),
        BookTitle: $("#RuleBookTitle").val(),
        ReportTitle: $("#RuleReportTitle").val(),
        ConferenceTitle: $("#RuleConferenceTitle").val(),
        ThesisTitle: $("#RuleThesisTitle").val(),
        conferenceName: $("#RuleConferenceName").val(),
        PaperTitle: $("#RulePaperTitle").val(),
        PageRange: $("#RulepageRange").val(),
        Notestyle: $("#RuleNoteStyle").val(),
        DataAvailabilitySection: $("#RuleDataAvailabilitySection").val(),
        EthicalApprovalSection: $("#RuleEthicalApprovalSection").val(),
        InformedConsentSection: $("#RuleInformedConsentSection").val(),
        TrialRegistrationSection: $("#RuleTrialRegistrationSection").val(),
        SupplementarySection: $("#RuleSupplementarySection").val(),
        AuthorContributionSection: $("#RuleAuthorContributionSection").val(),
        AbstractCount: $("#RuleAbstractCount").val(),
        GraphicalAbstract: $("#RuleGraphicalAbstract").val(),
        BackmatterOrder: $("#RuleBackmatterOrder").val(),
      };
      console.log(conversionrulesdata);

      ApiMethod.postMethod(this.modelItem.addUpdateConversionRulesAPI, conversionrulesdata).subscribe(
        response => {
          if (response.status) {
            this.cleardata();
            this.hideRules();
            this.GetConversionRules();

            ngswal("Success !", response.message, "success");
          } else {
            ngswal("Failed !", response.message, "warning");
          }
        }, error => {
          $("#LoadingImageReopen").hide();
          ngswal("Failed !", error.message, "error");
        });
      return false;
    }
  }

  cleardata() {

    $("#myModalRules textarea").val("");
    $("input[type='text']").val("");
    $("#ddlJournalList").val(0).change();
    $("#ddlPublisherType").val(0).change();
    $("#ddlProductType").val(0).change();
    $("#ddlReferenceStyle").val(0).change();
    $('#RulesDegrees').val(0).change();
    $('#RuleAffiliation').val(0).change();
    $('#RuleAbstracthead').val(0).change();
    $('#RuleDisclosureSection').val(0).change();
    $('#RuleFundingSection').val(0).change();
    $('#RuleCorresspondingAddress').val(0).change();

  }

  hideRules() {
    this.showRulesModal = false;
    $('a[href="#divRules1"]').click();
  }

  ConfirmationCloneConversionRules() {
    ngswal({
      title: "Are you confirm to Clone Conversion Rules?",
      text: "Clone Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Clone!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnCloneRule').trigger("click");
        } else {
          ngswal("Cancelled !", "You clicked cancel! :)", "warning");
        }
      });

  }

  CloneConversionRules() {
    $('#LoadingImage').show();
    ApiMethod.getMethod(this.modelItem.CloneConversionRules + '/' + localStorage.aEID + '/' + localStorage.aLoginID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hideRules();
        if (result.Status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
        }
        else {
          ngswal("Failed !", result.Message, "warning");
        }
        this.GetConversionRules();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }




}




